/* eslint-disable import/prefer-default-export */
import styled from "styled-components";
import { mediaMaxWidth } from "../../../theme/mediaQueriesTemplates";

type TextProps = {
  fontSize?: string;
  fontWeight?: string;
  fontStyle?: string;
  color?: string;
};

export const StyledText = styled.p<TextProps>`
  font-family: ${({ theme }) => theme.fontFamily};
  font-size: ${({ theme }) => theme.fontSize.normal.desktop};
  font-size: ${({ fontSize, theme }) =>
    fontSize === "xSmall" && theme.fontSize.xSmall.desktop};
  font-size: ${({ fontSize, theme }) =>
    fontSize === "small" && theme.fontSize.small.desktop};
  font-size: ${({ fontSize, theme }) =>
    fontSize === "normal" && theme.fontSize.normal.desktop};
  font-size: ${({ fontSize, theme }) =>
    fontSize === "large" && theme.fontSize.large.desktop};
  font-weight: ${({ fontWeight, theme }) =>
    fontWeight === "light" && theme.fontWeight.light};
  font-weight: ${({ fontWeight, theme }) =>
    fontWeight === "bolder" && theme.fontWeight.bolder};
  font-weight: ${({ fontWeight, theme }) =>
    fontWeight === "bold" && theme.fontWeight.bold};
  font-style: ${({ fontStyle }) => fontStyle || "normal"};
  color: ${({ color, theme }) => color === "primary" && theme.colors.primary};
  color: ${({ color, theme }) =>
    color === "secondary" && theme.colors.secondary};

  ${mediaMaxWidth.tablet} {
    font-size: ${({ theme }) => theme.fontSize.normal.mobile};
    font-size: ${({ fontSize, theme }) =>
      fontSize === "xSmall" && theme.fontSize.xSmall.mobile};
    font-size: ${({ fontSize, theme }) =>
      fontSize === "small" && theme.fontSize.small.mobile};
    font-size: ${({ fontSize, theme }) =>
      fontSize === "normal" && theme.fontSize.normal.mobile};
    font-size: ${({ fontSize, theme }) =>
      fontSize === "large" && theme.fontSize.large.mobile};
  }
`;

StyledText.displayName = "StyledText";
